import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { authenticatedRoute } from "../_authenticated.js";

export const dataRoomsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/data-rooms",
  component: lazyRouteComponent(() => import("./data-rooms.page.js"), "DataRoomsPage"),
});

export const dataRoomDetailRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/data-rooms/$roomId",
  component: lazyRouteComponent(() => import("./data-room-detail.page.js"), "DataRoomDetailPage"),
});
